import { render, staticRenderFns } from "./ElInputCommaNumber.vue?vue&type=template&id=661ec5a6"
import script from "./ElInputCommaNumber.vue?vue&type=script&lang=js"
export * from "./ElInputCommaNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports